import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
    en: {
        // Dashboard
        helpdeskDashboard: 'Helpdesk Dashboard',
        createNewTicket: 'Create New Ticket',
        viewAllTickets: 'View All Tickets',
        totalTickets: 'Total Tickets',
        open: 'Open',
        unassigned: 'Unassigned',
        myTickets: 'My Tickets',
        resolved: 'Resolved',
        today: 'Today',
        unassignedTickets: 'Unassigned Tickets',
        myAssignments: 'My Assignments',
        clients: 'Clients',
        categories: 'Categories',
        recentTickets: 'Recent Tickets',
        viewAll: 'View All',
        noTicketsYet: 'No tickets yet',
        
        // Table Headers
        ticketNumber: 'Ticket #',
        subject: 'Subject',
        client: 'Client',
        company: 'Company',
        assignedTo: 'Assigned To',
        status: 'Status',
        priority: 'Priority',
        created: 'Created',
        lastReply: 'Last Reply',
        actions: 'Actions',
        
        // Status Labels
        statusOpen: 'Open',
        statusAssigned: 'Assigned',
        statusInProgress: 'In Progress',
        statusWaiting: 'Waiting',
        statusResolved: 'Resolved',
        statusClosed: 'Closed',
        
        // Priority Labels
        priorityLow: 'Low',
        priorityMedium: 'Medium',
        priorityHigh: 'High',
        priorityCritical: 'Critical',
        
        // Tickets Page
        allTickets: 'All Tickets',
        searchTickets: 'Search tickets...',
        filterByStatus: 'Filter by Status',
        filterByPriority: 'Filter by Priority',
        allStatuses: 'All Statuses',
        allPriorities: 'All Priorities',
        
        // Create Ticket
        createTicket: 'Create Ticket',
        ticketInformation: 'Ticket Information',
        clientInformation: 'Client Information',
        selectExistingClient: 'Select Existing Client',
        orCreateNewClient: 'Or Create New Client',
        clientName: 'Client Name',
        clientEmail: 'Client Email',
        clientPhone: 'Client Phone',
        clientCompany: 'Client Company',
        category: 'Category',
        selectCategory: 'Select Category',
        selectPriority: 'Select Priority',
        ticketSubject: 'Ticket Subject',
        description: 'Description',
        attachments: 'Attachments',
        dragDropFiles: 'Drag & drop files here or click to browse',
        creating: 'Creating...',
        
        // Ticket Detail
        ticketDetails: 'Ticket Details',
        backToTickets: 'Back to Tickets',
        conversation: 'Conversation',
        addReply: 'Add Reply',
        internalNote: 'Internal Note',
        sendReply: 'Send Reply',
        typeYourReply: 'Type your reply here...',
        assignTicket: 'Assign Ticket',
        unassignTicket: 'Unassign',
        closeTicket: 'Close Ticket',
        reopenTicket: 'Reopen Ticket',
        changeStatus: 'Change Status',
        changePriority: 'Change Priority',
        ticketInfo: 'Ticket Info',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        clientInfo: 'Client Info',
        email: 'Email',
        phone: 'Phone',
        
        // Common
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        confirm: 'Confirm',
        yes: 'Yes',
        no: 'No',
        search: 'Search',
        filter: 'Filter',
        reset: 'Reset',
        unknown: 'Unknown',
        none: 'None',
        selectAgent: 'Select Agent',
        noAgentsAvailable: 'No agents available',
        
        // Tickets Page Additional
        tickets: 'tickets',
        allCategories: 'All Categories',
        allAssignments: 'All Assignments',
        date: 'Date',
        to: 'to',
        hideClosed: 'Hide Closed',
        clearFilters: 'Clear Filters',
        noTicketsFound: 'No tickets found',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
        of: 'of',
        
        // Create Ticket Page
        ticketDetails: 'Ticket Details',
        enterSubject: 'Enter ticket subject',
        describeIssue: 'Describe the issue in detail',
        assignTo: 'Assign To',
        addFiles: 'Add Files',
        maxFilesHint: 'Max 5 files, 10MB each',
        createNewClient: 'Create new client',
        searchClient: 'Search Client',
        searchClientPlaceholder: 'Type to search by name, email, or company...',
        noClientsFound: 'No clients found. Check "Create new client" to add one.',
        phoneNumber: 'Phone number',
        companyName: 'Company name',
        subjectRequired: 'Subject is required',
        descriptionRequired: 'Description is required',
        clientRequired: 'Please select a client or enter client email',
        ticketCreatedSuccess: 'Ticket created successfully!',
        createTicketFailed: 'Failed to create ticket',
        fileTooLarge: 'File exceeds 10MB limit',
        maxFilesError: 'Maximum 5 files allowed',
        
        // New Client Modal
        newClientConfirmation: 'New Client Confirmation',
        emailNotRegistered: 'This email is not registered with any existing client.',
        newClientWillBeCreated: 'A new client account will be created with this email. The client will receive a welcome email to set their password.',
        continue: 'Continue',
        goBack: 'Go Back',
    },
    ar: {
        // Dashboard
        helpdeskDashboard: 'لوحة تحكم الدعم الفني',
        createNewTicket: 'إنشاء تذكرة جديدة',
        viewAllTickets: 'عرض جميع التذاكر',
        totalTickets: 'إجمالي التذاكر',
        open: 'مفتوحة',
        unassigned: 'غير مُسندة',
        myTickets: 'تذاكري',
        resolved: 'تم حلها',
        today: 'اليوم',
        unassignedTickets: 'تذاكر غير مُسندة',
        myAssignments: 'المُسندة إليّ',
        clients: 'العملاء',
        categories: 'التصنيفات',
        recentTickets: 'التذاكر الأخيرة',
        viewAll: 'عرض الكل',
        noTicketsYet: 'لا توجد تذاكر بعد',
        
        // Table Headers
        ticketNumber: 'رقم التذكرة',
        subject: 'الموضوع',
        client: 'العميل',
        company: 'الشركة',
        assignedTo: 'مُسندة إلى',
        status: 'الحالة',
        priority: 'الأولوية',
        created: 'تاريخ الإنشاء',
        lastReply: 'آخر رد',
        actions: 'الإجراءات',
        
        // Status Labels
        statusOpen: 'مفتوحة',
        statusAssigned: 'مُسندة',
        statusInProgress: 'قيد التنفيذ',
        statusWaiting: 'في الانتظار',
        statusResolved: 'تم حلها',
        statusClosed: 'مغلقة',
        
        // Priority Labels
        priorityLow: 'منخفضة',
        priorityMedium: 'متوسطة',
        priorityHigh: 'عالية',
        priorityCritical: 'حرجة',
        
        // Tickets Page
        allTickets: 'جميع التذاكر',
        searchTickets: 'البحث في التذاكر...',
        filterByStatus: 'تصفية حسب الحالة',
        filterByPriority: 'تصفية حسب الأولوية',
        allStatuses: 'جميع الحالات',
        allPriorities: 'جميع الأولويات',
        
        // Create Ticket
        createTicket: 'إنشاء تذكرة',
        ticketInformation: 'معلومات التذكرة',
        clientInformation: 'معلومات العميل',
        selectExistingClient: 'اختر عميل موجود',
        orCreateNewClient: 'أو أنشئ عميل جديد',
        clientName: 'اسم العميل',
        clientEmail: 'البريد الإلكتروني',
        clientPhone: 'رقم الهاتف',
        clientCompany: 'الشركة',
        category: 'التصنيف',
        selectCategory: 'اختر التصنيف',
        selectPriority: 'اختر الأولوية',
        ticketSubject: 'عنوان التذكرة',
        description: 'الوصف',
        attachments: 'المرفقات',
        dragDropFiles: 'اسحب الملفات هنا أو اضغط للاختيار',
        creating: 'جاري الإنشاء...',
        
        // Ticket Detail
        ticketDetails: 'تفاصيل التذكرة',
        backToTickets: 'العودة للتذاكر',
        conversation: 'المحادثة',
        addReply: 'إضافة رد',
        internalNote: 'ملاحظة داخلية',
        sendReply: 'إرسال الرد',
        typeYourReply: 'اكتب ردك هنا...',
        assignTicket: 'إسناد التذكرة',
        unassignTicket: 'إلغاء الإسناد',
        closeTicket: 'إغلاق التذكرة',
        reopenTicket: 'إعادة فتح التذكرة',
        changeStatus: 'تغيير الحالة',
        changePriority: 'تغيير الأولوية',
        ticketInfo: 'معلومات التذكرة',
        createdAt: 'تاريخ الإنشاء',
        updatedAt: 'آخر تحديث',
        clientInfo: 'معلومات العميل',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        
        // Common
        loading: 'جاري التحميل...',
        save: 'حفظ',
        cancel: 'إلغاء',
        delete: 'حذف',
        edit: 'تعديل',
        confirm: 'تأكيد',
        yes: 'نعم',
        no: 'لا',
        search: 'بحث',
        filter: 'تصفية',
        reset: 'إعادة تعيين',
        unknown: 'غير معروف',
        none: 'لا يوجد',
        selectAgent: 'اختر موظف',
        noAgentsAvailable: 'لا يوجد موظفين متاحين',
        
        // Tickets Page Additional
        tickets: 'تذكرة',
        allCategories: 'جميع التصنيفات',
        allAssignments: 'جميع الإسنادات',
        date: 'التاريخ',
        to: 'إلى',
        hideClosed: 'إخفاء المغلقة',
        clearFilters: 'مسح الفلاتر',
        noTicketsFound: 'لا توجد تذاكر',
        previous: 'السابق',
        next: 'التالي',
        page: 'صفحة',
        of: 'من',
        
        // Create Ticket Page
        ticketDetails: 'تفاصيل التذكرة',
        enterSubject: 'أدخل عنوان التذكرة',
        describeIssue: 'وصف المشكلة بالتفصيل',
        assignTo: 'إسناد إلى',
        addFiles: 'إضافة ملفات',
        maxFilesHint: 'حد أقصى 5 ملفات، 10 ميجا لكل ملف',
        createNewClient: 'إنشاء عميل جديد',
        searchClient: 'البحث عن عميل',
        searchClientPlaceholder: 'اكتب للبحث بالاسم أو البريد أو الشركة...',
        noClientsFound: 'لم يتم العثور على عملاء. حدد "إنشاء عميل جديد" لإضافة واحد.',
        phoneNumber: 'رقم الهاتف',
        companyName: 'اسم الشركة',
        subjectRequired: 'العنوان مطلوب',
        descriptionRequired: 'الوصف مطلوب',
        clientRequired: 'يرجى اختيار عميل أو إدخال بريد العميل',
        ticketCreatedSuccess: 'تم إنشاء التذكرة بنجاح!',
        createTicketFailed: 'فشل في إنشاء التذكرة',
        fileTooLarge: 'الملف يتجاوز الحد المسموح 10 ميجا',
        maxFilesError: 'الحد الأقصى 5 ملفات',
        
        // New Client Modal
        newClientConfirmation: 'تأكيد إنشاء عميل جديد',
        emailNotRegistered: 'هذا البريد الإلكتروني غير مسجل مع أي عميل موجود.',
        newClientWillBeCreated: 'سيتم إنشاء حساب عميل جديد بهذا البريد. سيتلقى العميل رسالة ترحيب لتعيين كلمة المرور.',
        continue: 'استمر',
        goBack: 'تراجع',
    }
};

const HelpdeskLanguageContext = createContext();

export const useHelpdeskLanguage = () => {
    const context = useContext(HelpdeskLanguageContext);
    if (!context) {
        throw new Error('useHelpdeskLanguage must be used within HelpdeskLanguageProvider');
    }
    return context;
};

export const HelpdeskLanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('helpdesk_language') || 'en';
    });

    useEffect(() => {
        localStorage.setItem('helpdesk_language', language);
        // Update document direction for RTL support
        if (language === 'ar') {
            document.documentElement.setAttribute('dir', 'rtl');
        } else {
            document.documentElement.setAttribute('dir', 'ltr');
        }
    }, [language]);

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'en' ? 'ar' : 'en');
    };

    const t = (key) => {
        return translations[language][key] || key;
    };

    const isRTL = language === 'ar';

    return (
        <HelpdeskLanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, isRTL }}>
            {children}
        </HelpdeskLanguageContext.Provider>
    );
};

export default HelpdeskLanguageContext;
